import { styled } from 'styled-components';

import { tokens } from './FiltersBar.tokens.ts';

export const StyledFiltersBar = styled.div`
    // Avoid using a gap here, as we will require accordion children
    // to animate without inheriting a gap.
`;

export const StyledLayout = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    gap: ${tokens.layout.gap.mobile}px;

    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        gap: ${tokens.layout.gap.desktop}px;
    }
`;

export const StyledGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0 0 auto;
    gap: ${tokens.group.gap.mobile}px;

    @media (min-width: 768px) {
        gap: ${tokens.group.gap.desktop}px;
    }
`;

export const StyledSearchWrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
    gap: ${tokens.group.gap.mobile}px;
    width: 100%;
    min-width: ${tokens.search.minWidth}px;

    @media (min-width: 768px) {
        gap: ${tokens.group.gap.desktop}px;
        width: auto;
    }
`;
